angular.module('app').directive('selectUsuario', function() {
	return {
        restrict: 'E',
        template: function($element, attrs){
            var html = `
            <select class="form-control" 
                chosen
                ng-options="x.id as x.id+' - '+x.name+(x.cpf_cnpj ? ' - '+x.cpf_cnpj : '') for x in options" 
                ng-model="ngModel"
                ng-disabled="ngDisabled">
                <option value=""></value>
            </select>
        `;
        $jqueryElement = $(html);

            if(attrs.placeholder){
                $jqueryElement.attr('data-placeholder-text-single', "'"+attrs.placeholder+"'");
                $jqueryElement.find('option[value=""]').first().html(attrs.placeholder);
            }else{
                $jqueryElement.attr('data-placeholder-text-single', "' '");
            }

            if(attrs.required){
                $jqueryElement.attr('required', true);
            }

            return $jqueryElement[0].outerHTML;
        },
        scope: {
            ngModel: '=',
            ngDisabled: '='
        },
        controller: function($scope, $element, $http, $timeout, $compile) {
            $scope.options = [];

            $scope.comCampanha = 0;

            var base = window.location.protocol+'//'+window.location.hostname;
                base = base.replace('politica.', '');

            $scope.getOptions = function(){
                $http({
                    'url': base+'/admin/users/select?comCampanha='+$scope.comCampanha
                }).then(function(res){
                    $scope.options = res.data 
                });
            }
        },
        link: function ($scope, $element, attrs, ctrl) {
            
            if(typeof attrs['comCampanha'] !== 'undefined'){
                $scope.comCampanha = 1;
            }

            $scope.getOptions();
        }
    };
})